
import Modal from 'bootstrap/js/dist/modal';
import {config} from 'core/config';
import {spinner} from 'modules/spinner';

const SELECT = {
    'modal': '#modalQuestionsForm',
    'modalBody': '#modalQuestionsForm .modal-body',
    'modalForm': '#questionsForm',
    'modalClose': '#modalQuestionsForm .close',
    'captcha': '.js-captcha-QuestionsForm',
    'captchaUpdate': '.js-captcha-QuestionsForm-update',
};

export const questionsForm = {
    init: function() {
        this.formValidate();
        this.bindEvents();
    },
    bindEvents: function() {
        document.querySelector(SELECT.captchaUpdate).addEventListener('click', function() {
            const date = new Date();
            document.querySelector(SELECT.captcha).src = '/kcaptcha/imgc.php?d=' + date.getTime();
        });
    },
    formValidate: function() {
        window.addEventListener('load', function() {
            const forms = document.getElementsByClassName('needs-validation');
            const validation = Array.prototype.filter.call(forms, function(form) {
                form.addEventListener('submit', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    const params = new FormData(form);
                    if (form.checkValidity() === true) {
                        spinner.show(document.querySelector(SELECT.modalBody));
                        config.post('/Questions/create/', params, 'html').then((response) => {
                            if (response.includes('отправлено')) {
                                alert(response);
                                document.getElementById('questionsForm').reset();
                                form.classList.remove('was-validated');
                                const $modal = document.querySelector(SELECT.modal);
                                const modalInstance = Modal.getOrCreateInstance($modal);
                                modalInstance.hide();
                            } else {
                                alert(response);
                            }
                            spinner.hide(document.querySelector(SELECT.modalBody));
                        }).catch((errorText) => {
                            alert(errorText);
                        });
                    }
                    form.classList.add('was-validated');
                }, false);
            });
        }, false);
    },
};
